import { playChime, setSoundEnabled } from '../lib/sound.js';

/**
 * New-message sound toggle (batch-105). A pure leaf: the parent owns the
 * `enabled` state (via `useSoundEnabled`) and passes it down; clicking flips +
 * persists it and plays a confirmation chime when turning ON.
 *
 * Extracted from the retired `HeaderControls` cluster — it is the only piece of
 * that cluster still mounted (in the topbar). See batch-305 follow-up.
 */
export function SoundButton({ enabled }: { enabled: boolean }) {
  const label = enabled ? 'Mute new-message sounds' : 'Enable new-message sounds';
  return (
    <button
      type="button"
      onClick={() => {
        const next = !enabled;
        setSoundEnabled(next);
        // Play a confirmation chime when turning ON (also unlocks audio via the
        // click gesture so later auto-chimes are allowed to play).
        if (next) playChime('other');
      }}
      aria-label={label}
      aria-pressed={enabled}
      title={label}
      data-testid="sound-toggle"
      className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-zinc-800 bg-zinc-900/60 text-zinc-400 hover:border-zinc-700 hover:bg-zinc-800 hover:text-zinc-100"
    >
      {enabled ? <SpeakerIcon /> : <SpeakerMuteIcon />}
    </button>
  );
}

function SpeakerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M11 5 6 9H2v6h4l5 4z" />
      <path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a9 9 0 0 1 0 14" />
    </svg>
  );
}

function SpeakerMuteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M11 5 6 9H2v6h4l5 4z" />
      <path d="M22 9l-6 6M16 9l6 6" />
    </svg>
  );
}
